import { useState, useEffect, useMemo } from 'react';
import { getPrivileges } from '../api/services/payroll.service';


export const usePermissions = (menuId) => {
    const [privileges, setPrivileges] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const currentMenuId = menuId;

    useEffect(() => {
        if (!currentMenuId) {
            setPrivileges({ create: false, update: false, delete: false, view: false });
            setLoading(false);
            return;
        }

        let cancelled = false;
        const fetchPrivileges = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await getPrivileges({ MenuIds: currentMenuId });
                if (cancelled) return;

                const details = res?.Details?.[0];
                if (details) {
                    setPrivileges({
                        create: Boolean(details.Create),
                        update: Boolean(details.Update),
                        delete: Boolean(details.Delete),
                        view: Boolean(details.View),
                    });
                } else {
                     // If no details are returned, assume no permissions.
                     setPrivileges({ create: false, update: false, delete: false, view: false });
                }
            } catch (err) {
                if (!cancelled) {
                    console.error("Privilege error", err);
                    setError(err.message || 'Failed to fetch permissions.');
                    setPrivileges(null);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        fetchPrivileges();

        return () => {
            cancelled = true;
        };
    }, [currentMenuId]);

    const permissions = useMemo(() => ({
        canCreate: privileges?.create ?? false,
        canUpdate: privileges?.update ?? false,
        canDelete: privileges?.delete ?? false,
        // Default to true if not specified to avoid blank screens, can be configured if needed.
        canView: privileges?.view ?? true, 
    }), [privileges]);

    return { permissions, loading, error };
};

